import React, { useEffect, useState } from "react";
import { Wrench, Users, Nfc, LifeBuoy, Clock, MapPin } from "lucide-react";
import api from "../../../lib/api";
import { Label, StatCard, scoreColor } from "../../../components/common";

export default function PlatformOperations() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/operations").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-400">Loading…</div>;
  const t = d.totals;
  return (
    <div className="space-y-6">
      <div><Label>Platform</Label><h1 className="font-head text-2xl font-bold text-slate-900 sm:text-3xl">Operations Health</h1></div>
      <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-6">
        <StatCard label="Organisations" value={t.organizations} testId="ops-orgs" />
        <StatCard label="Locations" value={t.locations} testId="ops-locations"><MapPin className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="Employees" value={t.employees} testId="ops-employees"><Users className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="NFC Provisioned" value={`${t.provisioning_pct}%`} sub={`${t.nfc_provisioned} tags`} accent="#4338CA" testId="ops-nfc"><Nfc className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="Open Recovery" value={t.open_recovery} accent="#EF4444" testId="ops-recovery"><LifeBuoy className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="Avg Resolution" value={t.avg_resolution_hours != null ? `${t.avg_resolution_hours}h` : "—"} sub={t.avg_response_hours != null ? `${t.avg_response_hours}h response` : "—"} testId="ops-resolution"><Clock className="h-5 w-5 text-slate-300" /></StatCard>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <Label>Organisations needing attention</Label>
        <div className="mt-3 overflow-x-auto sv-scroll">
          <table className="w-full min-w-[560px] text-sm" data-testid="ops-table">
            <thead><tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400"><th className="py-2">Organisation</th><th>Open recovery</th><th>Service Index</th><th>Locations</th><th>Employees</th></tr></thead>
            <tbody>
              {d.organizations.map((o) => (
                <tr key={o.id} className="border-b border-slate-100" data-testid={`ops-org-${o.id}`}>
                  <td className="py-3 font-semibold text-slate-800">{o.name}</td>
                  <td><span className={`font-bold ${o.open_recovery > 0 ? "text-red-600" : "text-slate-400"}`}>{o.open_recovery}</span></td>
                  <td><span className="sv-metric font-bold" style={{ color: scoreColor(o.ssi) }}>{o.ssi.toFixed(2)}</span></td>
                  <td className="text-slate-500">{o.locations}</td>
                  <td className="text-slate-500">{o.employees}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
